import schema from './schema.js'
import editPagePageConfig from './editPage/pageConfig.js'
import listPagePageConfig from './listPage/pageConfig.js'

export default {
  title: '開立發票',
  schema,
  edit: editPagePageConfig,
  list: listPagePageConfig,
}
